import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import JumboSelect from '../JumboSelect';
import ActivityCard from '../ActivityCard';

const ICON_ASSET = require('./icon.svg');

export default class NeedsSelect extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.props.handler.bind(this);
  }

  render() {
    return (
      <JumboSelect
        label="Needs"
        icon={ICON_ASSET}
        selected={this.props.value ? this.props.value.length : 0}
        modifier="needs"
        clear={this.props.clear}
      >
        {
          this.props.needs.map(need => (
            <ActivityCard
              key={need.id}
              id={need.id}
              value={
                this.props.value && this.props.value.length > 0 &&
                this.props.value.find(needID => needID === need.id)
              }
              label={need.title}
              onSelect={this.handleSelect} />
          ))
        }
      </JumboSelect>
    );
  }
}

NeedsSelect.defaultProps = {
  value: [],
  handler: () => {},
  clear: () => {},
};

NeedsSelect.propTypes = {
  handler: PropTypes.func, //eslint-disable-line
  clear: PropTypes.func, //eslint-disable-line
  needs: PropTypes.array.isRequired,
  value: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/NeedsSelect/index.js